//import { tagsActions } from '../actions/tagsActions';
export const tagsActions = {
    GET_TAG_TYPES_LIST: 'GET_TAG_TYPES_LIST',
    CREATE_TAG_TYPE: 'CREATE_NEW_TAG_TYPE',
    DELETE_TAG_TYPE: 'DELETE_TAG_TYPE',
    UPDATE_TAG_TYPE: 'UPDATE_TAG_TYPE',
    REFRESH_DELETE_TAG_TYPE: 'REFRESH_DELETE_TAG_TYPE',
    ADD_TAG_TO_OBJECT: 'ADD_TAG_TO_OBJECT',
    GET_OBJECT_TAGS: 'GET_OBJECT_TAGS',
    REMOVE_TAG_FROM_OBJECT: 'REMOVE_TAG_FROM_OBJECT',
    GET_TAGS_FOR_TAG_TYPE: 'GET_TAGS_FOR_TAG_TYPE',
    REFRESH_DELETE_TAG: 'REFRESH_DELETE_TAG',
    GET_OBJECT_TYPES: 'GET_OBJECT_TYPES'
};
const initState = {
    tagTypes:[]
};

export const tagTypesReducer = (state = initState, action: any) => {
    switch (action.type) {
        case tagsActions.CREATE_TAG_TYPE:
            return Object.assign({}, state, {
                tagTypes: [action.payload, ...state.tagTypes]
            });

        case tagsActions.GET_TAG_TYPES_LIST:
            return Object.assign({}, state, {
                tagTypes: [...action.payload]
            });

        case tagsActions.REFRESH_DELETE_TAG_TYPE:
            const tagTypes = state.tagTypes.filter(item => item.id != action.payload);
            return Object.assign({}, state, {
                tagTypes: tagTypes || null
            });

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/store/reducers/tagTypesReducer.ts